import { Modal } from "antd";
import { BellOutlined } from "@ant-design/icons";

const NotificationPermissionModal = ({ visible, onAllow, onDeny }) => {
  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <BellOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
          <span>Enable Notifications</span>
        </div>
      }
      onOk={onAllow}
      onCancel={onDeny}
      okText="Allow"
      cancelText="Not Now"
      centered
      maskClosable={false}
    >
      <p>
        Stay updated with real-time notifications about important updates,
        messages, and alerts.
      </p>
      <p style={{ marginBottom: 0, color: "#666" }}>
        You can change this preference anytime in your browser settings.
      </p>
    </Modal>
  );
};

export default NotificationPermissionModal;
